import { render, staticRenderFns } from "./UserCompanyChangePopup.vue?vue&type=template&id=aa67fefc&scoped=true&"
import script from "./UserCompanyChangePopup.vue?vue&type=script&lang=js&"
export * from "./UserCompanyChangePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa67fefc",
  null
  
)

export default component.exports